import { render } from "./TeacherManagement.vue?vue&type=template&id=0fc86f9d"
import script from "./TeacherManagement.vue?vue&type=script&lang=js"
export * from "./TeacherManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__